import { apiGet, apiPost, apiPut } from "@redriver/cinnamon";

const NAMESPACE = "DEALER_ADDITIONAL_DOCUMENTS";

export const ActionTypes = {
  UploadIntroductionTemplate: `${NAMESPACE}/UPLOAD_INTRODUCTION_TEMPLATE`,
  UploadAssignmentTemplateSPV: `${NAMESPACE}/UPLOAD_ASSIGNMENT_TEMPLATE_SPV`,
  UploadAssignmentTemplateCustomer: `${NAMESPACE}/UPLOAD_ASSIGNMENT_TEMPLATE_CUSTOMER`,
  GetIntroductionTemplates: `${NAMESPACE}/GET_INTRODUCTION_TEMPLATES`,
  GetAssignmentTemplatesSPV: `${NAMESPACE}/GET_ASSIGNMENT_TEMPLATES_SPV`,
  GetAssignmentTemplatesCustomer: `${NAMESPACE}/GET_ASSIGNMENT_TEMPLATES_CUSTOMER`,
  ApproveAdditionalDocument: `${NAMESPACE}/APPROVE_ADDITIONAL_DOCUMENT`,
  DownloadAdditionalDocument: `${NAMESPACE}/DOWNLOAD_ADDITIONAL_DOCUMENT`,
};

export const getIntroductionTemplates = (dealerId) =>
  apiGet(
    ActionTypes.GetIntroductionTemplates,
    `dealers/${dealerId}/introduction-template`,
  );

export const getAssignmentTemplatesSPV = (dealerId) =>
  apiGet(
    ActionTypes.GetAssignmentTemplatesSPV,
    `dealers/${dealerId}/assignment-template-spv`,
  );

export const getAssignmentTemplatesCustomer = (dealerId) =>
  apiGet(
    ActionTypes.GetAssignmentTemplatesCustomer,
    `dealers/${dealerId}/assignment-template-customer`,
  );

const uploadTemplate =
  (actionType, urlPath) =>
  ({ templateUpload, reference }, { dealerId, uploadDoc }) => {
    const fileUploadObject = !uploadDoc
      ? null
      : {
          name: templateUpload.name,
          content: uploadDoc.split(",")[1],
          size: templateUpload.size,
          contentType: templateUpload.type,
        };
    return apiPost(actionType, `dealers/${dealerId}/${urlPath}/upload`, {
      Data: fileUploadObject,
      Reference: reference,
    });
  };

export const uploadIntroductionTemplate = uploadTemplate(
  ActionTypes.UploadIntroductionTemplate,
  "introduction-template",
);

export const uploadAssignmentTemplateSPV = uploadTemplate(
  ActionTypes.UploadAssignmentTemplateSPV,
  "assignment-template-spv",
);

export const uploadAssignmentTemplateCustomer = uploadTemplate(
  ActionTypes.UploadAssignmentTemplateCustomer,
  "assignment-template-customer",
);

export const approveAdditionalDocument = ({ id }) =>
  apiPut(
    ActionTypes.ApproveAdditionalDocument,
    `additional-document/${id}/approve`,
  );

export const downloadAdditionalDocument = ({ id }) =>
  apiGet(
    ActionTypes.DownloadAdditionalDocument,
    `additional-document/${id}/download`,
  );
